<template>
  <div id="diagnostic" class="d-flex">
    <MainBarMenuV2/>
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">
      <router-link to="/employee" class="mt-4 col-10 p-2 mx-auto d-flex align-items-center container back">
            <span class="icon-arrow-left2 mr-4"></span>
            <p class="mb-0 d-none d-lg-block">Conceptos Medicos</p>
      </router-link>
      <div class="row mt-5">
        <div class="col-10 mx-auto my-5">
          <h2 class="mt-4">Enfermedad de Origen {{completeDiagnostic.diagnosis.origin == 'occupational'? 'Laboral':'Común'}}</h2>
          <!-- informacion del trabajador -->
          <WorkerInfo :dataUser="employeeInfo.data.employee" />
          <div class="mt-5" v-if="loadingFD" id="loader"></div>
          <div v-else>
            <div class="d-flex align-items-center">
              <h2 class="m-0">{{completeDiagnostic.diagnosis.diagnosis}}</h2>
              <h3 class="status ml-3 p-2 font-weight-bold rounded-pill">{{status}}</h3>
            </div>
            <p>Categoria: {{completeDiagnostic.diagnosis.category}}</p>
            <div class="d-flex align-items-stretch">
              <div v-for="(date,index) of dates" :key="index" class="col-3 p-0 mt-4">
                <div class="rounded p-4 mx-2" :class="date.class">
                  <p class="font-weight-bold" style="font-size:16px">{{date.title}}</p>
                  <p class="m-0" style="font-size:14px;color:#000000">{{date.entity}}</p>
                  <p style="font-size:14px;color:#454545;">{{date.date}}</p>
                </div>
              </div>
            </div>
            <div class="risk p-4 mt-4">
              <p class="font-weight-bold" style="font-size:16px">Riesgo Asociado</p>
              <p class="m-0" style="font-size:14px;color:#000000">{{completeDiagnostic.diagnosis.risk_associated}}</p>
            </div>
            <div class="mt-5" v-if="loadingFD2" id="loader"></div>
            <div v-if="this.completeDiagnostic.first_qualification && !loadingFD2" class="mt-5">
              <h2 class="mb-3">Trazabilidad del diagnostico </h2>
              <b-tabs  v-model="tabIndex">
                <!-- Primer TAB -->
                <b-tab title="Calificación">
                  <!-- Tabla de califiaciónes anteriores -->

                  <div class="shadow table-diagnostics">
                    <div class="p-3">
                      <b-table
                          :items="allCalifications.items"
                          :fields="allCalifications.fields"
                      >
                      </b-table>
                    </div>
                    <!-- <div
                        class="col-12 cont-pagination my-5 d-flex justify-content-center"
                    >
                        <Pagination
                        :data="gesHistory"
                        :limit="10"
                        @pagination-change-page="getHistoryGes"
                        ></Pagination>
                    </div> -->
                  </div>
                </b-tab>
                <b-tab title="APT" @click="getAPTs()" :disabled="!completeDiagnostic.apt">
                  <!-- Tabla de APTs -->
                  <div class="shadow table-diagnostics">
                    <div class="p-3">
                      <b-table
                          :items="allAPTs.items"
                          :fields="allAPTs.fields"
                      >
                        <template #cell(file)="row">
                          <div v-if="row.item.file" class="d-flex justify-content-between">
                            <a :href="serverPath + '/' + row.item.file" class="d-flex align-items-center" target="_blank">
                              Ver archivo Adjunto
                              <span class="icon-eye ml-3 icon" style="font-size:13px;color:#2E5AAC"></span>
                            </a>
                          </div>
                          <p v-else>---</p>
                        </template>

                      </b-table>
                    </div>
                    <!-- <div
                        class="col-12 cont-pagination my-5 d-flex justify-content-center"
                    >
                        <Pagination
                        :data="gesHistory"
                        :limit="10"
                        @pagination-change-page="getHistoryGes"
                        ></Pagination>
                    </div> -->
                  </div>
                </b-tab>
                <b-tab title="PCL" @click="getPCLs()" :disabled="!completeDiagnostic.pcl">
                  <!-- Tabla de PCLs -->
                  <div class="shadow table-diagnostics">
                    <div class="p-3">
                      <b-table
                          :items="allPCLs.items"
                          :fields="allPCLs.fields"
                      >
                        <template #cell(file)="row">
                          <div v-if="row.item.file" class="d-flex justify-content-between">
                            <a :href="serverPath + '/' + row.item.file" class="d-flex align-items-center" target="_blank">
                              Ver archivo Adjunto
                              <span class="icon-eye ml-3 icon" style="font-size:13px;color:#2E5AAC"></span>
                            </a>
                          </div>
                          <p v-else>---</p>
                        </template>
                        <template #cell(compensation)="row">
                                        <span
                                            class="status"
                                            :style="'background-color:' + row.item.compensation.color"
                                        >
                                        <img
                                            class="centerImg1 mr-1"
                                            :src="require('@/assets/images/icons/' + row.item.compensation.icon)"
                                            width="20px"
                                        />
                                        {{ row.item.compensation.text }}
                                        </span>
                        </template>
                      </b-table>
                    </div>
                    <!-- <div
                       class="col-12 cont-pagination my-5 d-flex justify-content-center"
                   >
                       <Pagination
                       :data="gesHistory"
                       :limit="10"
                       @pagination-change-page="getHistoryGes"
                       ></Pagination>
                   </div> -->
                  </div>
                </b-tab>
              </b-tabs>
            </div>
            <div v-if="completeDiagnostic.diagnosis.observations_diagnosis" class="my-5">
              <h2>Observaciones del Diagnostico</h2>
              <p>{{completeDiagnostic.diagnosis.observations_diagnosis}}</p>
            </div>
            <div v-if="completeDiagnostic.diagnosis.observations_investigation" class="my-5">
              <h2>Observaciones de la investigación</h2>
              <p>{{completeDiagnostic.diagnosis.observations_investigation}}</p>
            </div>

            <div class="table-diagnostics mt-5">
              <h2>Incapacidades</h2>
              <div class="p-3">
                <b-table
                    :items="allDisabilities.items"
                    :fields="allDisabilities.fields"
                >
                  <template #cell(certificate)="row">
                                        <span
                                            class="status"
                                            :style="'background-color:' + row.item.certificate.color"
                                        >
                                        <img
                                            class="centerImg1 mr-1"
                                            :src="require('@/assets/images/icons/' + row.item.certificate.icon)"
                                            width="20px"
                                        />
                                        {{ row.item.certificate.text }}
                                        </span>
                  </template>
                </b-table>
              </div>
              <!-- <div
              class="col-12 cont-pagination my-5 d-flex justify-content-center"
          >
              <Pagination
              :data="gesHistory"
              :limit="10"
              @pagination-change-page="getHistoryGes"
              ></Pagination>
          </div> -->
            </div>
          </div>
        </div>
      </div>

    </div>
   </div> 
</template>
 
<script>
import { mapState,mapActions } from "vuex";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import WorkerInfo from "../../components/healthTracker/workerInfo.vue";
import serverConfig from "./../../services/config";
export default {
    components: {
        MainBarMenuV2,
        HeadingUser,
        WorkerInfo
    },
    data() {
        return {
            serverPath: serverConfig.permisosURL,
            dates:[],
            status:'',
            responsibleOptions:[],
            tabIndex:0,
            originOptions:[
                {value:'occupational',text:'Laboral'},
                {value:'regular',text:'Común'},
            ],
            allCalifications:{
                fields:[],
                items:[]
            },
            allAPTs:{
                fields:[],
                items:[]
            },
            allPCLs:{
                fields:[],
                items:[]
            },
            allDisabilities:{
                fields:[],
                items:[]
            },
        }
    },
    beforeMount(){
        this.actGetCompleteDiagnostic(this.$route.params.id).then(()=> {
            this.getResponsibles()
            this.getCalifications()
            this.diagnosticDates()
            this.qualification()
            this.getDisabilities()
        })
    },
    computed: {
        ...mapState("modOhAnalyst", [
            "employeeInfo",
        ]),
        ...mapState("modDiagnostics", [
            "loadingFD",
            "completeDiagnostic",
            "tableCalifications",
            "tableAPTs",
            "tablePCLs",
            "list",
            "loadingFD2",
        ]),
    },
    methods:{
        ...mapActions("modDiagnostics", [
            'actGetCompleteDiagnostic',
            'actGetListCalification',
            'actGetListAPT',
            'actGetListPCL',
            'actGetListsForDiagnostics'
        ]),
        diagnosticDates(){
            if(this.completeDiagnostic.first_qualification){
                this.dates.push(
                    {
                        title:'Primera Calificación',
                        entity:'Diagnosticada por ' + this.completeDiagnostic.first_qualification.entity,
                        date:this.completeDiagnostic.first_qualification.date,
                        class:'dates'
                    }
                )
            }else{
                this.dates.push(
                    {
                        title:'Primera Calificación',
                        entity:'No ha sido realizada',
                        class:'no-dates'
                    }
                )
            }
            if(this.completeDiagnostic.last_qualification){
                this.dates.push(
                {
                    title:'Ultima calificación',
                    entity:'Diagnosticada por ' + this.completeDiagnostic.last_qualification.entity,
                    date:this.completeDiagnostic.last_qualification.date,
                    class:'dates'
                }
                )
            }else{
                this.dates.push(
                    {
                        title:'Ultima calificación',
                        entity:'No ha sido realizada',
                        class:'no-dates'
                    }
                )
            }
            if(this.completeDiagnostic.apt){
                this.dates.push(
                {
                    title:'Análisis de Puesto de Trabajo',
                    entity:'Realizada por ' + this.completeDiagnostic.apt.entity,
                    date:this.completeDiagnostic.apt.date,
                    class:'dates'
                }
                )
            }else{
                this.dates.push(
                    {
                        title:'Análisis de Puesto de Trabajo',
                        entity:'No ha sido realizado',
                        class:'no-dates'
                    }
                )
            }
            if(this.completeDiagnostic.pcl){
                this.dates.push(
                {
                    title:'PCL',
                    entity:'Calificada por ' + this.completeDiagnostic.pcl.entity,
                    date:this.completeDiagnostic.pcl.date,
                    class:'dates'
                }
            )
            }else{
                this.dates.push(
                    {
                        title:'PCL',
                        entity:'No ha sido realizado',
                        class:'no-dates'
                    }
                )
            }
        },
        qualification(){
            switch (this.completeDiagnostic.diagnosis.status) {
                case 'Qualified':
                    this.status = 'Calificada / En firme'
                    break;
                case 'controversy':
                    this.status = 'Controversia'
                    break;
                case 'study':
                    this.status = 'En estudio'
                    break;
            }
        },

        // Trae la información de los entes responsables

        getResponsibles(){
            this.actGetListsForDiagnostics().then(() => {
                this.list.entity_responsible_diagnosis.forEach(x => {
                    this.responsibleOptions.push({
                        value:x.id,
                        text:x.name
                    })
                })
            })
        },
        // Trae todas las calificaciones de un diagnostico

        getCalifications(){
            this.actGetListCalification(this.$route.params.id).then(() => {
                this.tabIndex = 0
                this.allCalifications.items = [];
                this.allCalifications.fields = [
                    {
                        key: 'date',
                        label:'Fecha de calificación'
                    },
                    {
                        key: 'origin',
                        label: 'Concepto del origen'
                    },
                    {
                        key:'responsable',
                        label: 'Ente responsable',
                    }
                ];
                this.tableCalifications.data.forEach((x) => {
                        let responsibleName = ''
                        let originName = ''
                        this.responsibleOptions.forEach(y => {
                            if(x.entity_responsible_diagnosis_id == y.value){
                                responsibleName = y.text
                            }
                        })
                        this.originOptions.forEach(y => {
                            if(x.origin_code == y.value){
                                originName = y.text
                            }
                        })
                        this.allCalifications.items.push({
                            origin: originName,
                            responsable:responsibleName,
                            date:x.date
                        })
                })
            })
        },
        getAPTs(){
            this.actGetListAPT(this.employeeInfo.data.employee.id).then(() => {
                this.tabIndex = 1
                this.allAPTs.items = [];
                this.allAPTs.fields = [
                    {
                        key: 'date',
                        label:'Fecha de calificación'
                    },
                    {
                        key:'responsable',
                        label: 'Ente Responsable',
                    },
                    {
                        key: 'file',
                        label: 'Adjunto'
                    }
                ];
                this.tableAPTs.data.forEach((x) => {
                        let responsibleName = ''
                        this.responsibleOptions.forEach(y => {
                            if(x.entity_responsible_diagnosis_id == y.value){
                                responsibleName = y.text
                            }
                        })
                        this.allAPTs.items.push({
                            responsable:responsibleName,
                            file:(x.file == null? null:x.file),
                            date:x.date
                        })
                })
            })
        },
        getPCLs(){
            this.actGetListPCL(this.employeeInfo.data.employee.id).then(() => {
                this.tabIndex = 2
                this.allPCLs.items = [];
                this.allPCLs.fields = [
                    {
                        key: 'date',
                        label:'Fecha de calificación'
                    },
                    {
                        key:'responsable',
                        label: 'Ente Responsable',
                    },
                    {
                        key:'responsableC',
                        label: 'Responsable de la compensación',
                    },
                    {
                        key:'compensation',
                        label: 'Compensación',
                    },
                    {
                        key: 'file',
                        label: 'Archivo'
                    }
                    
                ];
                this.tablePCLs.data.forEach((x) => {
                        let responsibleName = ''
                        let responsibleNameC = ''
                        let status = {}
                        switch (x.was_compensated) {
                            case 0:
                            status = {
                                color: "#FFF4EC",
                                icon: "orange-clock.svg",
                                text: "Pendiente",
                            };
                            break;
                            case 1:
                            status = {
                                color: "#EDF9F0",
                                icon: "check.svg",
                                text: "Realizada",
                            };
                            break;
                        }
                        this.responsibleOptions.forEach(y => {
                            if(x.entity_responsible_diagnosis_id == y.value){
                                responsibleName = y.text
                            }
                            if(x.entity_responsible_compensated_id == y.value){
                                responsibleNameC = y.text
                            }
                        })
                        this.allPCLs.items.push({
                            responsable:responsibleName,
                            responsableC:responsibleNameC,
                            file:(x.file == null? null:x.file),
                            date:x.date,
                            compensation:status
                        })
                })
            })
        },

        getDisabilities(){
                this.allDisabilities.items = [];
                this.allDisabilities.fields = [
                    {
                        key: 'start_date',
                        label:'Fecha de Inicio'
                    },
                    {
                        key:'end_date',
                        label: 'Fecha Final',
                    },
                    {
                        key:'days',
                        label: 'Días',
                    },
                    {
                        key:'type',
                        label: 'Tipo',
                    },
                    {
                        key: 'origin',
                        label: 'Origen de Incapacidad'
                    },
                    {
                        key: 'transmitter',
                        label: 'Emisor'
                    },
                    {
                        key: 'certificate',
                        label: 'Certificado'
                    }
                    
                ];
                this.completeDiagnostic.disabilities.data.forEach((x) => {
                        let status = {}
                        switch (x.certificate) {
                            case 'pending':
                            status = {
                                color: "#FFF4EC",
                                icon: "orange-clock.svg",
                                text: "Pendiente",
                            };
                            break;
                            case 'received':
                            status = {
                                color: "#EDF9F0",
                                icon: "check.svg",
                                text: "Recibido",
                            };
                            break;
                        }
                        this.allDisabilities.items.push({
                            start_date:x.start_date,
                            end_date:x.end_date,
                            days:x.days,
                            type:x.type,
                            origin:(!x.origin?'Inicial':'Prorroga'),
                            transmitter:x.transmitter,
                            certificate:status
                        })
                })
        },
    }
}
</script>

<style lang="scss">
#diagnostic{
    .back{
        color: #269887;
    }
    .status{
        background: #EEF2FA;
        color: #2E5AAC;
    }
    .dates{
        font-family: Open Sans;
        background:#E9ECEE;
        height: 120px;
    }
    .no-dates{
        font-family: Open Sans;
        background:white;
        border: solid rgb(185, 185, 185) 1px;
        color:rgb(185, 185, 185);
        height: 120px;
    }
    .nav-tabs{
        a{
            color:black;
            padding: 5px 15px;
        }
        a.active {
            background: rgba(38, 152, 135, 0.06);
            border-radius: 4px;
            border: 0;
            border-bottom: solid 3px;
            border-color: #269887;
        }
            font-family: Open Sans;
    }
    .table-diagnostics {
        font-family: Open Sans;
        font-size: 14px;
        font-style: normal;
        text-align: left;
        font-weight: 100;
        thead {
        background-color: #eef2fa;
        border-radius: 10px;
        border: none;
            th {
                border: none;

            }
        }
    }
    .risk{
        font-family: Open Sans;
        background:#F5F5F5;
    }
    .status {
    padding: 5px 10px;
    border-radius: 20px;
    font-size: 14px;
  }
}
</style>